import { defineStyleConfig } from '@chakra-ui/system';

export const Spinner = defineStyleConfig({
    sizes: {
        xl: {
            h: '5rem',
            w: '5rem',
        },
    },
});
